import {Api, decryptApiResponse} from '../../../config/Api'
import {statusAndResponse} from "../../../util/requestHandler";
import {getDateAsString} from "../../../util/date";

export function getSftpFilesList(f) {
  const filter = {...f}

  if (filter.createdStart && filter.createdEnd) {
    filter.createdStart = getDateAsString(new Date(filter.createdStart), 'yyyy-MM-dd', 'YYYY-MM-DD')
    filter.createdEnd = getDateAsString(new Date(filter.createdEnd), 'yyyy-MM-dd', 'YYYY-MM-DD')
  }
  else if(filter.createdStart) {
    filter.created = getDateAsString(filter.createdStart, 'yyyy-MM-dd', 'YYYY-MM-DD')
    delete filter.createdStart
  }

  return statusAndResponse(
    Api.get(`/api/sftp/files`, {params: filter}),
    decryptApiResponse
  )
}